import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button, DataTable } from "../../components";
import { Paper } from "@mui/material";
import MaskCPFCNPJ from "../../helpers/maskCpfCnpj";
import { KeyboardArrowLeftOutlined, KeyboardArrowRightOutlined } from "@mui/icons-material";
import formatName from "../../helpers/formatName";
import { formatCelular } from "../../helpers";
import ButtonComponent from "../../components/ButtonComponent";
import ModalAddEmpresa from "./cadastro/add";
import * as types from '../../store/types/usuarios'
import Loading from "../../components/Loading";
import { useNavigate } from "react-router-dom";
import { loadUsuarios } from "../../store/actions/usuarios";

function UsuariosApp() {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const { usuarios, page, per_page, total } = useSelector(
    (state) => state.usuarios
  );
  const [filtro, setFiltro] = useState("");
  const [filtroAtualizado, setFiltroAtualizado] = useState("");
  const [openModalInformations, setOpenModalInformations] = useState(false);
  const [modalOpenAdd, setModalOpenAdd] = useState(false);
  const [loading, setLoading] = useState(false)

  async function GetDataLoad() {
    setLoading(true)
    const data = {
      page: page,
      per_page: per_page,
      filtro: filtroAtualizado,
      status: "A",
    };
    await loadUsuarios(data);
    setLoading(false)

    setFiltroAtualizado(""); // Limpa o estado após a requisição
  }

  const navigatePages = (validations) => {
    dispatch({ type: types.USUARIOS_DATA_PAGE, payload: validations });
  };

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      if (filtro === "") {
        GetDataLoad(); // Se filtro está vazio, chama a função GetDataLoad diretamente
      } else {
        setFiltroAtualizado(filtro);
      }
    }, 500);

    return () => clearTimeout(timeoutId);
  }, [filtro, page]);

  useEffect(() => {
    if (filtroAtualizado !== "") {
      GetDataLoad();
    }
  }, [filtroAtualizado, page]);



  const styledBtnArrows = {
    display: "flex",
    alignContent: "center",
    alignItems: "center",
    border: "none",
    cursor: "pointer",
    margin: 15,
    backgroundColor: "transparent",
    fontFamily: "Poppins",
  };

  const columns = [
    { title: "Nome", render: ({ nome }) => formatName(nome) },
    { title: "E-mail", render: ({ email }) => email }  
  ];

  const handleRowClick = (event, rowData) => {
    // navigate(`/app/empresas/${rowData.id}`);
    dispatch({ type: types.USUARIOS_SELECIONADA_DATA, payload: rowData });
    setOpenModalInformations(true);
  };


  return (
    <div>
      <Loading loading={loading}/>
      <div style={{display: "flex", flexDirection: 'row', justifyContent: 'space-between'}}>
      <h4>Usuários plataforma</h4>
      <ButtonComponent onClick={() => setModalOpenAdd(true)}>Adicionar usuario</ButtonComponent>
      </div>
      <Paper elevation={1} style={{ padding: 5 }}>
        <DataTable
          columns={columns}
          data={usuarios}
          enableHover={true}
          options={{
            defaultMessage: "Não há registros para serem exibidos.",
            rowStyle: { backgroundColor: "#ffffff", cursor: "pointer" },
            cellStyle: { border: "1px solid #ddd" },
          }}
          onRowClick={handleRowClick}
        />
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            alignContent: "center",
            alignItems: "center",
            fontFamily: "Poppins",
            fontSize: 14,
            justifyContent: "flex-end",
          }}
        >
          <div
            style={{ marginRight: 30, display: "flex", flexDirection: "row" }}
          >
            {+page !== 1 && (
              <button
                style={styledBtnArrows}
                onClick={() => navigatePages(+page - 1)}
              >
                <KeyboardArrowLeftOutlined /> Anterior{" "}
              </button>
            )}

            {usuarios?.length !== 0 && (
              <button
                style={styledBtnArrows}
                onClick={() => navigatePages(+page + 1)}
              >
                Próximo <KeyboardArrowRightOutlined />
              </button>
            )}
          </div>
          <p>
            Pagina <b>{page}</b> | Total de registros{" "}
            <b>{total}</b>
          </p>
        </div>
      </Paper>

            <ModalAddEmpresa
              open={modalOpenAdd}
              close={() => setModalOpenAdd(false)}
              updateList={() => GetDataLoad()}
            />

    </div>
  );
}

export default UsuariosApp;
